/* Primary navigation. `count` badges are placeholders until wired to live data
   (e.g. unworked-lead count from D1 in a later phase). */
export interface NavEntry {
  path: string;
  icon: string;
  label: string;
  count?: number;
  /** Match children too (e.g. /content/request under contentIQ). */
  end?: boolean;
}

export const NAV: NavEntry[] = [
  { path: '/', icon: 'home', label: 'tritonIQ Dashboard', end: true },
  { path: '/leads', icon: 'users', label: 'leadIQ' },
  { path: '/traffic', icon: 'trending-up', label: 'trafficIQ' },
  { path: '/campaigns', icon: 'target', label: 'campaignIQ' },
  { path: '/reviews', icon: 'star', label: 'reviewsIQ' },
  { path: '/conversation', icon: 'message', label: 'conversationIQ' },
  { path: '/content', icon: 'bar-chart', label: 'contentIQ' },
];
